// Файл auth_effects.js

// Все useEffect:
// таймер блокировки,
// автопроверка авторизации и восстановление согласий

import { useEffect } from 'react';



const use_auth_effects = ({
    auth_locked_until,
    set_auth_lock_remaining,
    set_auth_locked_until,
    is_consent_still_valid,
    PD_STORAGE_KEY,
    COOKIE_STORAGE_KEY,
    set_pd_already_accepted,
    set_is_pd_accepted,
    set_cookies_already_accepted,
    set_is_cookies_accepted,
    apiService,
    redirect_after_login,
    auth_check_started_ref,
}) => {
    useEffect(() => {
        if (!auth_locked_until) return;

        const tick = () => {
            const diff = Math.max(
                0,
                Math.floor((new Date(auth_locked_until).getTime() - Date.now()) / 1000)
            );

            set_auth_lock_remaining(diff);

            if (diff <= 0) {
                set_auth_locked_until(null);
                set_auth_lock_remaining(0);
            }
        };

        tick();
        const timer = setInterval(tick, 1000);
        return () => clearInterval(timer);
    }, [auth_locked_until, set_auth_lock_remaining, set_auth_locked_until]);

    useEffect(() => {
        if (auth_check_started_ref.current) 
            return;
        
        auth_check_started_ref.current = true;

        const check = async () => {
            try {
                const res = await apiService.df({ table_name: 'check_auth' });

                if (res.response !== 'Вы не авторизованы') {
                    await redirect_after_login();
                }
            } catch {
                return;
            }
        };

        check();
    }, [apiService, redirect_after_login, auth_check_started_ref]);

    useEffect(() => {
        if (is_consent_still_valid(PD_STORAGE_KEY)) {
            set_pd_already_accepted(true);
            set_is_pd_accepted(true);
        }

        if (is_consent_still_valid(COOKIE_STORAGE_KEY)) {
            set_cookies_already_accepted(true);
            set_is_cookies_accepted(true);
        }
    }, [
        COOKIE_STORAGE_KEY,
        PD_STORAGE_KEY,
        is_consent_still_valid,
        set_cookies_already_accepted,
        set_is_cookies_accepted,
        set_pd_already_accepted,
        set_is_pd_accepted,
    ]);
};


export {
    use_auth_effects,
};
